import FilterableAttributes from "component/product/FilterableAttributes";
import PartNumber from "component/product/PartNumber";
import SafeLink from "modules/components/SafeLink";
import RatingUI from "modules/third-party/sitejabber/RatingUI";
import HideIf from "util/HideIf";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import { getProductHeading } from "../../util/product/get-product-heading";
import styles from "./productDescription.module.scss";

function ProductDescription(props: any) {
  const {
    item,
    manufacturer = item.manufacturer,
    upc = item.upc,
    sku = item.sku,
    canonicalUrl = item.canonicalUrl,
    className = "",
    useUrlAsHref = "",
    hideManufacturer = false,
  } = props;

  const renderitem = (
    <>

      <div className={styles.item_description} data-testid="item-description">
        {

          getProductHeading(item)
        }
      </div>

      <HideIf show={!hideManufacturer}>
        <div className={styles.item_manufacturer} data-testid="item-manufacturer">
          {`by ${ manufacturer}`}
        </div>
        <PartNumber product={item} />
      </HideIf>

      <FilterableAttributes product={item} />

      <RatingUI
        {...{
          PRODUCT_ID: upc || sku,
        }}
      />
    </>
  );
  if (!canonicalUrl) {
    return (
      <div className={`item-sku-link ${className}`}>
        {renderitem}
      </div>
    );
  }
  let { href, asPath } = getHrefAndPath({ asPath: canonicalUrl });
  if (useUrlAsHref) {
    href = useUrlAsHref;
    asPath = useUrlAsHref;
  }
  return (
    <SafeLink href={href} asPath={asPath} className={`item-sku-link ${className}`}>
      {renderitem}
    </SafeLink>
  );
}

export default ProductDescription;
